(() => {
  if (window.__printoraMobileSearchFix) return;
  window.__printoraMobileSearchFix = true;

  const initialise = () => {
    const sidebar = document.getElementById('search-form-mobile');
    if (!sidebar) return;

    if (sidebar.parentElement !== document.body) {
      document.body.appendChild(sidebar);
    }

    const input = sidebar.querySelector('#Search-In-Modal-Sidebar');
    let focusTimer;

    const sync = () => {
      const open = document.body.classList.contains('open_search_mobile');
      document.body.classList.toggle('printora-search-open', open);
      document.documentElement.classList.toggle('printora-search-open', open);
      sidebar.setAttribute('aria-hidden', open ? 'false' : 'true');

      window.clearTimeout(focusTimer);
      if (open && input) {
        focusTimer = window.setTimeout(() => {
          try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
        }, 220);
      }
    };

    const observer = new MutationObserver(sync);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('click', event => {
      if (event.target.closest('[data-search-mobile]')) {
        window.setTimeout(sync, 0);
      }
      if (event.target.closest('[data-search-close-sidebar], .header-search-close')) {
        window.setTimeout(sync, 80);
      }
    }, true);

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !document.body.classList.contains('open_search_mobile')) return;
      const close = sidebar.querySelector('[data-search-close-sidebar]');
      if (close) close.click();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024) {
        document.body.classList.remove('printora-search-open');
        document.documentElement.classList.remove('printora-search-open');
      }
    }, { passive: true });

    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
